/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiScreeningPersonScreeningContextConfiguration
 */
export interface ApiScreeningPersonScreeningContextConfiguration {
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningPersonScreeningContextConfiguration
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningPersonScreeningContextConfiguration
     */
    field: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiScreeningPersonScreeningContextConfiguration
     */
    normalisable?: boolean;
}

/**
 * Check if a given object implements the ApiScreeningPersonScreeningContextConfiguration interface.
 */
export function instanceOfApiScreeningPersonScreeningContextConfiguration(value: object): value is ApiScreeningPersonScreeningContextConfiguration {
    if (!('field' in value) || value['field'] === undefined) return false;
    return true;
}

export function ApiScreeningPersonScreeningContextConfigurationFromJSON(json: any): ApiScreeningPersonScreeningContextConfiguration {
    return ApiScreeningPersonScreeningContextConfigurationFromJSONTyped(json, false);
}

export function ApiScreeningPersonScreeningContextConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningPersonScreeningContextConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'field': json['field'],
        'normalisable': json['normalisable'] == null ? undefined : json['normalisable'],
    };
}

export function ApiScreeningPersonScreeningContextConfigurationToJSON(json: any): ApiScreeningPersonScreeningContextConfiguration {
    return ApiScreeningPersonScreeningContextConfigurationToJSONTyped(json, false);
}

export function ApiScreeningPersonScreeningContextConfigurationToJSONTyped(value?: ApiScreeningPersonScreeningContextConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'field': value['field'],
        'normalisable': value['normalisable'],
    };
}

